import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import { Credencial } from '../../Cadastro/Credencial';
import api from '../../../../services/api';

export function CredencialPerfil({ usuarioId }) {
  const [id, setId] = useState();

  useEffect(() => {
    let mounted = true;
    async function buscarUsuario() {
      const response = await api.get(`/usuario?id=${usuarioId}`);

      if (mounted) {
        setId(response.data.id.toString());
      }
    }
    buscarUsuario();

    return () => {
      mounted = false;
    };
  }, [usuarioId]);

  return (
    <>
      <Skeleton loading={!id} active />
      {id && <Credencial id={id} confirmPassword={true} deslogar={true} />}
    </>
  );
}
